import { AggregateEvaluationLifecycleOutputDto } from './../../../../data-transfer/entities/aggregate-evaluation-lifecycle-output-dto';
import { LifeCycleAggregatedEvaluationResult } from './../../../../util/analyses-util/live-cycle/life-cycle-aggregated-evaluation-result';
import { Component, Input, SimpleChanges, OnChanges } from '@angular/core';
import { EnvironmentalEffectDto } from 'src/app/data-transfer/entities/environmental-effect-dto';
import { ECOINVENT_VERSION, LifeCycleAnalysisInformation } from 'src/app/model/life-cycle-data-information';
import {LicenseService} from 'src/app/services/licensing-service'
import {DomSanitizer} from '@angular/platform-browser';
import { TranslocoService } from '@jsverse/transloco';
import {CountryDto} from './../../../../data-transfer/entities/country-dto'
import {BuyType} from 'src/app/components/shared-components/shop/buying-from-shop/buying-from-shop.component'
import { LCAAnalysisType } from 'src/app/data-transfer/entities/environmental-effect-authorization-dto';
@Component({
  selector: 'app-view-lifecycle-aggregate-evaluation',
  templateUrl: './view-lifecycle-aggregate-evaluation.component.html',
  styleUrls: ['./view-lifecycle-aggregate-evaluation.component.scss']
})
export class ViewLifecycleAggregateEvaluationComponent implements OnChanges {

  @Input() lcaEvaluation: AggregateEvaluationLifecycleOutputDto | null = null;
  @Input() isDarkTheme = false;

  lcaChartDataSource!: LifeCycleAggregatedEvaluationResult;
  selectedEffectIdx = 0;
  ecoinventVersion = ECOINVENT_VERSION;
  allowedEffects : EnvironmentalEffectDto[] = [];
  allowedCountries: CountryDto[] = [];
  showBuyText: boolean = false;
  buyType = BuyType;

  constructor(private lcaInfo: LifeCycleAnalysisInformation,
              private licenseService: LicenseService,
              private sanitizer : DomSanitizer,
              private translateService: TranslocoService) {

    this.allowedEffects = licenseService.allowedEffects.get(LCAAnalysisType.CradleToGrave) ?? [];
    this.allowedCountries = licenseService.allowedCountries;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.lcaEvaluation && changes.lcaEvaluation.currentValue) {
      this.lcaChartDataSource = new LifeCycleAggregatedEvaluationResult(changes.lcaEvaluation.currentValue, this.lcaInfo);
    }
  }

  protected getTooltipName(efftectIndex: number) {
    const effect = this.lcaChartDataSource.effectsInfo[efftectIndex];
    if (this.isEffectAuthorizedIntern(effect.key)) {
      return '';
    } else {
      return this.translateService.translate('analysis.lifecycleAnalysis.warnings.impactNotAuthorized',{name: ''});
    }
  }

  protected isEffectAuthorized(efftectIndex: number) : boolean {
    const effect = this.lcaChartDataSource.effectsInfo[efftectIndex];
    return this.isEffectAuthorizedIntern(effect.key);
  }

  private isEffectAuthorizedIntern(efftectName: string) : boolean {
    return this.allowedEffects.some((effect: EnvironmentalEffectDto) => effect.name == efftectName);
  }

  protected sanitize(url:string){
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

}
